<!-- =========================================================================================
    File Name: CardBasic.vue
    Description: Basic Cards
    ----------------------------------------------------------------------------------------
    Item Name: Vuesax Admin - VueJS Dashboard Admin Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->

<template>
  <div id="demo-basic-card">
    <vs-popup class="qr-show" title="fullscreen" :active.sync="qr.show">
      <img class="w-full" :src="qr.data" />
    </vs-popup>

    <div class="vx-row mb-10">
      <div class="vx-col w-full">
        <vx-card title="Outstanding Invoices">
          <div slot="no-body" class="mt-4">
            <vs-table :data="fundsTransformed">
              <template slot="thead">
                <vs-th>Date</vs-th>
                <vs-th>Invoice#</vs-th>
                <vs-th>Product</vs-th>
                <vs-th>Balance</vs-th>
                <vs-th>Released</vs-th>
                <vs-th>Payment</vs-th>
                <vs-th>&nbsp;</vs-th>
              </template>

              <template slot-scope="{ data }">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td :data="data[indextr].orderNo">
                    <span class="inline-block">{{
                      getDate(data[indextr].createdAt)
                    }}</span>
                  </vs-td>

                  <vs-td :data="data[indextr].orderNo">
                    <span>{{
                      (data[indextr] && data[indextr].uid) || "N/A"
                    }}</span>
                  </vs-td>

                  <vs-td :data="data[indextr].orderNo">
                    <span>{{ data[indextr].item.product.title }}</span>
                  </vs-td>

                  <vs-td :class="data[indextr].balance ? 'text-danger' : ''">
                    <!-- <vs-progress :percent="data[indextr].paidPerc" color="danger"></vs-progress> -->
                    {{ formatPrice(data[indextr].balance) }}
                  </vs-td>

                  <vs-td>
                    <span
                      >{{ data[indextr].item.released }} /
                      {{ data[indextr].item.quantity }}</span
                    >
                  </vs-td>

                  <vs-td>
                    {{ data[indextr].type.toUpperCase() }}
                  </vs-td>

                  <vs-td :data="data[indextr].orderNo">
                    <vs-button
                      size="small"
                      v-if="data[indextr].balance"
                      @click="addPayment(data[indextr])"
                      >$ Add Payment</vs-button
                    >
                    <vs-button
                      v-if="
                        data[indextr].item.quantity >
                          data[indextr].item.released
                      "
                      size="small"
                      @click="release(data[indextr])"
                      class="mt-2 md:mt-0 md:ml-2"
                      color="warning"
                      >Release Tickets</vs-button
                    >
                  </vs-td>
                </vs-tr>
              </template>
            </vs-table>
          </div>
        </vx-card>
      </div>
    </div>

    <div class="vx-row">
      <template v-for="crd in credits">
        <template v-if="crd.ticketsReleased - crd.ticketsUsed || crd.active">
          <div
            class="vx-col w-full sm:w-1/2 md:w-1/2 lg:w-1/4 xl:w-1/4 mb-base"
            :key="crd.id"
          >
            <statistics-card-line
              icon="ShoppingCartIcon"
              :statistic="(crd.ticketsReleased - crd.ticketsUsed).commarize()"
              :statisticTitle="`${crd.title} Credits`"
              :chartData="{}"
              type="area"
              custom="bare"
              class="relative stats-card"
            />
          </div>
        </template>
      </template>
    </div>
    <div class="vx-row" v-if="account && account.id && account.name">
      <div class="vx-col w-full md:w-1/2 mb-base centerx labelx">
        <vx-card :title="`General Information`">
          <vs-input
            label="Account Name"
            placeholder="Name"
            class="w-full mb-4"
            v-model="account.name"
          />
          <vs-input
            label="User Email"
            disabled
            placeholder="Email"
            type="email"
            class="w-full mb-4"
            v-model="user.email"
          />
          <vs-input
            label="Address"
            placeholder="Address"
            class="w-full mb-4"
            v-model="account.address"
          />
          <vs-input
            label="City"
            placeholder="City"
            class="w-full mb-4"
            v-model="account.city"
          />
          <vs-input
            label="Province"
            placeholder="Province"
            class="w-full mb-4"
            v-model="account.region"
          />
          <hr class="mt-10 mb-4 border-gray-300" />
          <vs-input
            label="Jonas Customer Code"
            placeholder="Customer Code"
            class="w-full mb-4"
            v-model="account.code"
          />
          <hr class="mt-10 mb-4 border-gray-300" />

          <vs-button class="mt-4" @click="save">Update</vs-button>
          <!-- <vs-button type="border" color="warning" @click="name = email = msg =''" class="mt-3">Cancel</vs-button> -->
        </vx-card>
        <vx-card :title="`Contact Info`" class="mt-4">
          <div
            v-for="(item, itemI) in additionalContacts"
            :key="`additional-${itemI}`"
          >
            <hr v-if="itemI" class="mb-base" />
            <div class="flex">
              <h4 style="color:#ccc">#{{ itemI + 1 }}.</h4>
              <div class="flex-1 ml-2">
                <div class="vx-row">
                  <div class="vx-col w-full centerx labelx">
                    <vs-input
                      label="Contact Name"
                      placeholder="Name"
                      class="w-full mb-4"
                      v-model="item.name"
                    />
                  </div>
                  <div class="vx-col w-2/5 mb-base centerx labelx">
                    <vs-input
                      label="Email"
                      placeholder="Contact Email"
                      class="w-full mb-4"
                      v-model="item.email"
                    />
                  </div>
                  <div class="vx-col w-2/5 mb-base centerx labelx">
                    <vs-input
                      label="Phone#"
                      placeholder="Contact Phone"
                      type="email"
                      class="w-full mb-4"
                      v-model="item.phone"
                    />
                  </div>
                  <div class="vx-col w-1/5 mb-base centerx labelx">
                    <vs-button
                      class="mt-6"
                      color="danger"
                      @click="deleteContact(itemI)"
                      icon-pack="feather"
                      icon="icon-trash"
                      style="border-radius:100%;"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="flex justify-between">
            <vs-button class="mt-4" @click="updateContacts"
              >Update Contacts</vs-button
            >
            <vs-button
              type="border"
              color="warning"
              @click="addAdditionalContact"
              class="mt-3"
              icon-pack="feather"
              icon="icon-plus"
            >
              Add Contact
            </vs-button>
          </div>
        </vx-card>
      </div>

      <div class="vx-col w-full sm:w-1/2 md:w-1/2 mb-base">
        <vx-card title="Manage Preferences">
          <div class="">
            <p class="text-md text-black font-bold">Over Draft Limit</p>
            <template v-for="(item, itemKey) in options.overDraft">
              <template v-if="productObj[itemKey]">
                <div :key="itemKey" class="flex items-center">
                  <span style="min-width:100px;">{{
                    productObj[itemKey].title
                  }}</span>
                  <vs-input-number
                    class="mb-4 ml-4"
                    v-model="options.overDraft[itemKey]"
                  />
                </div>
              </template>
            </template>

            <p class="text-md text-black font-bold mt-10">
              Quick Release Limit
            </p>

            <template v-for="(item, itemKey) in options.quickRelease">
              <template v-if="productObj[itemKey]">
                <div :key="itemKey + 'asdf'" class="flex items-center">
                  <span style="min-width:100px;">{{
                    productObj[itemKey].title
                  }}</span>
                  <vs-input-number
                    class="mb-4 ml-4"
                    v-model="options.quickRelease[itemKey]"
                  />
                </div>
              </template>
            </template>

            <p class="text-md text-black font-bold mt-10">
              Minimum Notification Threshold
            </p>
            <template v-for="(item, itemKey) in options.quickRelease">
              <template v-if="productObj[itemKey]">
                <div :key="itemKey + 'xxxx'" class="flex items-center">
                  <span style="min-width:100px;">{{
                    productObj[itemKey].title
                  }}</span>
                  <vs-input-number
                    class="mb-4 ml-4"
                    v-model="options.minNotification[itemKey]"
                  />
                </div>
              </template>
            </template>

            <vs-button class="mt-4" @click="updatePreferences"
              >Update Preference</vs-button
            >
          </div>
        </vx-card>
      </div>
    </div>

    <div class="vx-row">
      <div class="vx-col w-full lg:w-1/2 sm:w-1/2 mb-base">
        <vx-card title="Trucks">
          <!-- title="Gradient Background Color"
                    title-color="#fff"
                    content-color="#fff"
                    card-background="linear-gradient(to right, #56ab2f, #a8e063)" -->
          <vs-table :data="trucks" v-if="Object.keys(trucks).length">
            <template slot="thead">
              <vs-th>Lic Plate</vs-th>
              <vs-th>Truck Name</vs-th>
              <vs-th>QR Code</vs-th>
              <vs-th>Status</vs-th>
              <vs-th></vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="tr.licPlate">
                  {{ tr.licPlate }}
                </vs-td>

                <vs-td :data="tr.name">
                  {{ tr.name }}
                  <template slot="edit">
                    <div class="py-3 flex">
                      <vs-input v-model="tr.name" />
                      <vs-button
                        @click.native="update('trucks', tr)"
                        radius
                        color="primary"
                        type="filled"
                        icon-pack="feather"
                        icon="icon-check"
                      ></vs-button>
                    </div>
                  </template>
                </vs-td>

                <vs-td :data="tr">
                  <a @click.prevent="qrClick(tr)" href="#">PDF</a>
                </vs-td>

                <vs-td :data="tr.status">
                  <div class="flex items-center justify-start w-full truckStyle">
                    <label :for="'activeToggle'+tr.id" class="flex items-center cursor-pointer">
                      <div class="relative">
                        <input :id="'activeToggle'+tr.id" type="checkbox" class="sr-only" v-model="tr.status" @change="trStatus(tr)"/>
                        <div class="w-10 h-6 bg-gray-400 rounded-full shadow-inner" style="background: #b5b5b5;"></div>
                        <div class="dot absolute w-6 h-6 bg-white rounded-full shadow -left-1 -top-1 transition"></div>
                      </div>
                      <!-- label -->
                      <div class="ml-3 text-gray-700 font-medium">{{tr.status ? 'Active': 'Inactive'}}</div>
                    </label>
                  </div>
                </vs-td>

                <vs-td :data="tr.id">
                  <!-- <a @click.prevent="qrClick(tr)" href="#">Edit</a> -->
                  <vs-button
                    @click.native="deleteItem('trucks', tr)"
                    radius
                    color="danger"
                    type="filled"
                    icon-pack="feather"
                    size="small"
                    icon="icon-trash"
                  ></vs-button>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
          <p v-else>
            No Trucks found
          </p>
          <template slot="footer">
            <vs-divider />
            <div class="flex justify-between">
              <span class="flex items-center">
                <feather-icon
                  icon="TruckIcon"
                  svgClasses="h-5 w-5 text-primary stroke-current"
                />
                <span class="ml-2">{{ trucks.length }} Truck(s)</span>
              </span>
              <div class="flex items-center">
                <vs-button
                  radius
                  @click.native="addTruck = true"
                  color="primary"
                  type="filled"
                  icon-pack="feather"
                  icon="icon-plus"
                ></vs-button>
              </div>
            </div>
          </template>
        </vx-card>
      </div>
      <div class="vx-col w-full lg:w-1/2 sm:w-1/2 mb-base">
        <vx-card title="Drivers">
          <vs-table :data="drivers" v-if="Object.keys(drivers).length">
            <template slot="thead">
              <vs-th>First Name</vs-th>
              <vs-th>Lastname</vs-th>
              <vs-th>Status</vs-th>
              <!-- <vs-th v-if="false">Drivers Lic#</vs-th> -->
              <vs-th>&nbsp;</vs-th>
            </template>

            <template slot-scope="{ data }">
              <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data">
                <vs-td :data="tr">
                  {{ tr.firstName }}
                  <template slot="edit">
                    <div class="py-3 flex">
                      <vs-input v-model="tr.firstName" />
                      <vs-button
                        @click.native="update('drivers', tr)"
                        radius
                        color="primary"
                        type="filled"
                        icon-pack="feather"
                        icon="icon-check"
                      ></vs-button>
                    </div>
                  </template>
                </vs-td>

                <vs-td :data="tr">
                  {{ tr.lastName }}
                  <template slot="edit">
                    <div class="py-3 flex">
                      <vs-input v-model="tr.lastName" />
                      <vs-button
                        @click.native="update('drivers', tr)"
                        radius
                        color="primary"
                        type="filled"
                        icon-pack="feather"
                        icon="icon-check"
                      ></vs-button>
                    </div>
                  </template>
                </vs-td>

                <vs-td :data="tr">
                  <div class="flex items-center justify-start w-full truckStyle">
                    <label :for="'activeToggle'+tr.id" class="flex items-center cursor-pointer">
                      <div class="relative">
                        <input :id="'activeToggle'+tr.id" type="checkbox" class="sr-only" v-model="tr.status" @change="drStatus(tr)"/>
                        <div class="w-10 h-6 bg-gray-400 rounded-full shadow-inner" style="background: #b5b5b5;"></div>
                        <div class="dot absolute w-6 h-6 bg-white rounded-full shadow -left-1 -top-1 transition"></div>
                      </div>
                      <!-- label -->
                      <div class="ml-3 text-gray-700 font-medium">{{tr.status ? 'Active': 'Inactive'}}</div>
                    </label>
                  </div>
                </vs-td>

                <vs-td :data="tr.lic" v-if="false">
                  {{ tr.lic }}
                  <template slot="edit">
                    <div class="py-3 flex">
                      <vs-input v-model="tr.lic" />
                      <vs-button
                        @click.native="update('drivers', tr)"
                        radius
                        color="primary"
                        type="filled"
                        icon-pack="feather"
                        icon="icon-check"
                      ></vs-button>
                    </div>
                  </template>
                </vs-td>

                <vs-td>
                  <vs-button
                    @click.native="deleteItem('drivers', tr)"
                    radius
                    color="danger"
                    type="filled"
                    icon-pack="feather"
                    size="small"
                    icon="icon-trash"
                  ></vs-button>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
          <p v-else>
            No Drivers found
          </p>
          <template slot="footer">
            <vs-divider />
            <div class="flex justify-between">
              <span class="flex items-center">
                <feather-icon
                  icon="UserIcon"
                  svgClasses="h-5 w-5 text-primary stroke-current"
                />
                <span class="ml-2">{{ drivers.length }} Driver(s)</span>
              </span>
              <div class="flex items-center">
                <vs-button
                  radius
                  @click.native="addDriver = true"
                  color="primary"
                  type="filled"
                  icon-pack="feather"
                  icon="icon-plus"
                ></vs-button>
              </div>
            </div>
          </template>
        </vx-card>
      </div>
    </div>
    <div class="vx-row" id="activity">
      <div
        class="vx-col w-full lg:w-1/2 sm:w-1/2 mb-base"
        v-if="activities.length"
      >
        <vx-card title="Transaction Timeline">
          <ul class="activity-timeline">
            <template v-for="item in activities">
              <li :key="item.id">
                <div
                  class="timeline-icon"
                  :class="`bg-${activityLookup[item.what].color}`"
                >
                  <feather-icon
                    :icon="activityLookup[item.what].icon"
                    svgClasses="text-white stroke-current w-5 h-5"
                  ></feather-icon>
                </div>

                <div class="timeline-info" v-if="item.what === 'used'">
                  <p class="font-semibold">{{ item.product.title }} Ticket</p>
                  <span class="activity-desc">Used</span>
                </div>
                <div class="timeline-info" v-else-if="item.what === 'paid'">
                  <p class="font-semibold">
                    {{ formatPrice(item.amount) }} Paid
                  </p>
                  <span class="activity-desc"
                    >Invoice #{{ item.ticketOrder.uid }}</span
                  >
                </div>
                <div class="timeline-info" v-else>
                  <p class="font-semibold" v-if="item.orderItems.length === 1">
                    {{ item.orderItems[0].product.title }} ({{
                      item.orderItems[0].quantity
                    }}
                    Tickets)
                  </p>
                  <p class="font-semibold" v-else>
                    {{ item.orderItems.length }} Products ({{
                      getTicketCount(item.orderItems)
                    }}
                    Tickets total)
                  </p>
                  <span class="activity-desc"
                    >Purchased (Invoice# {{ item.uid }})</span
                  >
                </div>
                <small class="text-grey activity-e-time">{{
                  formatDate(item.createdAt)
                }}</small>
              </li>
            </template>
          </ul>
          <vs-button
            @click.native="
              $router.push({
                name: 'Transactions',
                params: { account: account.id }
              })
            "
            color="warning"
            >View All Transactions</vs-button
          >
        </vx-card>
      </div>
      <div class="vx-col w-full lg:w-1/2 sm:w-1/2 mb-base">
        <vx-card title="Advanced">
          <vs-button color="danger" @click="deleteCustomer"
            >Delete Customer</vs-button
          >
        </vx-card>
      </div>
    </div>

    <vs-prompt
      @cancel="cancelRelease"
      @accept="releaseFunds"
      title="Manually Release Funds"
      :active.sync="fund.show"
    >
      <div class="centerx">
        How much would you like to <b>release</b>. You can release a maximum of
        {{ fund.max }} credits.
        <div>
          <vs-input-number min="1" :max="fund.max" v-model="fund.amount" />
        </div>
      </div>
    </vs-prompt>

    <vs-prompt
      @cancel="cancelPayment"
      @accept="makePayment"
      title="Making Payment"
      :active.sync="payment.show"
    >
      <div class="centerx">
        There is a balance of <b>{{ formatPrice(payment.balance) }}</b>

        <div class="mt-5">
          <vs-select
            v-model="payment.type"
            class="w-full select-large"
            label="Payment Type"
            placeholder="Select Payment Type"
            style="max-width:200px"
          >
            <vs-select-item
              :key="item.value"
              :value="item.value"
              :text="item.label"
              v-for="item in paymentOptions"
              class="w-full"
            />
          </vs-select>
        </div>

        <div class="mt-3">
          <label for="" class="vs-input--label"
            >Payment Amount : {{ formatPrice(payment.amount) }}</label
          >
          <div class="flex">
            <vs-input-number
              min="1"
              :max="payment.balance"
              v-model="payment.amount"
            />
          </div>
        </div>
        <div class="mt-3">
          <vs-input
            label="Reference ID (Cheque# / EFT#)"
            v-model="payment.referenceId"
          />
        </div>
        <div class="mt-3" style="max-width:150px">
          <label for="" class="vs-input--label">Payment Date</label>
          <Datepicker
            v-model="payment.date"
            placeholder="Select Payment Date"
          />
        </div>
        <div class="mt-5">
          <label for="" class="text-lg">
            After payment, there will be a balance of
            <span class="block text-primary">{{
              formatPrice(payment.balance - payment.amount)
            }}</span>
          </label>
        </div>
      </div>
    </vs-prompt>

    <vs-prompt
      @cancel="clearValMultiple"
      @accept="addItem('trucks')"
      title="Add Truck"
      :is-valid="validName"
      :active.sync="addTruck"
    >
      <div class="con-exemple-prompt">
        Enter the Truck's Information below and click Accept to <b>continue</b>.
        <vs-input
          placeholder="Name"
          v-model="truck.name"
          class="mt-4 mb-2 w-full"
        />
        <vs-input
          placeholder="License Plate"
          :value="truckLic"
          @input="e => (truck.licPlate = e)"
          class="w-full"
        />

        <vs-alert v-show="!validName" color="danger" vs-icon="new_releases">
          Fields can not be empty please enter the data
        </vs-alert>
      </div>
    </vs-prompt>

    <vs-prompt
      @cancel="clearValMultiple"
      @accept="addItem('drivers')"
      :is-valid="validDriver"
      title="Add Driver"
      :active.sync="addDriver"
    >
      <div class="con-exemple-prompt">
        Enter the Driver's Information below and click Accept to
        <b>continue</b>.
        <vs-input
          placeholder="Firstname"
          v-model="driver.firstName"
          class="mb-2 mt-4 w-full"
        />
        <vs-input
          placeholder="Lastname"
          v-model="driver.lastName"
          class="mt-4 w-full"
        />
        <vs-input
          v-if="false"
          placeholder="Driver License"
          v-model="driver.lic"
          class="mt-4 w-full"
        />

        <vs-alert
          v-show="!validDriver"
          color="danger"
          vs-icon="new_releases"
          class="mt-2"
        >
          Fields can not be empty please enter the data
        </vs-alert>
      </div>
    </vs-prompt>
  </div>
</template>

<script>
import {
  arrToObj,
  formatDate,
  formatPrice,
  setProp,
  deleteProp,
  $loading,
  $load,
  getDate
} from "@/assets/helper";
import StatisticsCardLine from "@/components/statistics-cards/StatisticsCardLine.vue";
import Datepicker from "vuejs-datepicker";

export default {
  components: {
    StatisticsCardLine,
    Datepicker
  },
  watch: {
    account(val) {},
    addTruck() {
      this.truck = {
        name: "",
        licPlate: ""
      };
    }
  },
  data() {
    return {
      additionalContacts: [
        {
          name: "",
          phone: "",
          email: ""
        }
      ],
      qr: {
        show: false,
        data: null
      },
      activities: [],
      activityLookup: {
        used: {
          color: "primary",
          icon: "TruckIcon"
        },
        ordered: {
          color: "danger",
          icon: "ShoppingCartIcon"
        },
        paid: {
          color: "warning",
          icon: "DollarSignIcon"
        }
      },
      payment: {
        balance: 10000,
        amount: 0,
        show: false,
        type: "",
        ticketOrder: "",
        referenceId: "",
        date: new Date()
      },
      fund: {
        max: 10000,
        amount: 0,
        show: false,
        product: "",
        id: ""
      },

      addDriver: false,
      addTruck: false,
      val: "",
      driver: {
        firstName: "",
        lastName: "",
        lic: ""
      },
      truck: {
        name: "",
        licPlate: ""
      },
      productObj: {},
      allFunds: {},
      credits: {},
      relations: {},
      preferences: {},

      name: "",
      email: "",
      msg: "",
      playerOptions: {
        height: "460",
        fluid: true,
        autoplay: false,
        muted: true,
        language: "en",
        playbackRates: [0.7, 1.0, 1.5, 2.0],
        sources: [
          { type: "video/mp4", src: "http://vjs.zencdn.net/v/oceans.mp4" }
        ],
        poster: "https://goo.gl/xcCsDd"
      },
      settings: {
        // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: 0.6
      },
      chatMsgInput: "",
      chatMsg: [
        {
          senderImg: "avatar-s-2.png",
          msg: "Cake sesame snaps cupcake gingerbread",
          isSent: false
        },
        {
          senderImg: "avatar-s-5.png",
          msg: "Apple pie pie jujubes chupa chups muffin",
          isSent: true
        },
        { senderImg: "avatar-s-2.png", msg: "Chocolate cake", isSent: false },
        {
          senderImg: "avatar-s-5.png",
          msg: "Donut sweet pie oat cake dragée fruitcake",
          isSent: true
        },
        {
          senderImg: "avatar-s-2.png",
          msg: "Liquorice chocolate bar jelly beans icing",
          isSent: false
        },
        { senderImg: "avatar-s-5.png", msg: "Pudding candy", isSent: true }
      ],
      options: {},
      account: {},
      user: {},
      trucks: [],
      drivers: [],
      userEmail: "",
      origAccount: {}
    };
  },
  computed: {
    paymentOptions: () => [
      {
        label: "Cheque",
        value: "cheque"
      },
      {
        label: "EFT",
        value: "eft"
      }
    ],
    truckLic() {
      let { licPlate } = this.truck;
      return licPlate.replace(/ /g, "").toUpperCase();
    },
    funds(){
      let lines = [];
      Object.values(this.allFunds).forEach(x => {
        let { orderItems, ticketsReleased = [], payments = [], ...line } = x;

        const paidAmount = payments.reduce((sum, paid) => sum + paid.amount, 0);
        line.paidAmount = paidAmount;
        line.balance = line.total - paidAmount;
        line.paidPerc = (paidAmount / line.total) * 100;

        orderItems.forEach(item => {
          const released = ticketsReleased
            .filter(({ product }) => product === item.product.id)
            .reduce((sum, { quantity = 0 }) => sum + quantity, 0);

          item.released = released;
          lines.push({ ...line, item });
        });
      });
      return lines;
    },
    fundsTransformed() {
      if (!this.funds) return [];
      return Object.values(this.funds);
    },
    products() {
      return this.$store.state.products;
    },
    validName() {
      return (
        this.truck.name.trim().length > 0 &&
        this.truck.licPlate.trim().length > 0
      );
    },
    validDriver() {
      return (
        this.driver.firstName.trim().length > 0 &&
        this.driver.lastName.trim().length > 0
      );
    }
  },
  methods: {
    getDate,
    formatDate,
    formatPrice,
    $load,
    deleteContact(idx) {
      this.additionalContacts.splice(idx, 1);
      if (!this.additionalContacts.length) {
        this.additionalContacts = [
          {
            name: "",
            phone: "",
            email: ""
          }
        ];
      }
    },
    updateContacts() {
      this.additionalContacts = this.additionalContacts.filter(item => {
        return item.name.length && (item.email.length || item.phone.length);
      });
      if (!this.additionalContacts.length) {
        this.additionalContacts = [
          {
            name: "",
            email: "",
            phone: ""
          }
        ];
      }

      this.$update(`/accounts/${this.account.id}`, {
        contacts: this.additionalContacts
      })
        .then(({ data }) => {
          this.$store.commit("SET_PROP", {
            where: ["accounts", data.id],
            what: data
          });
          this.$vs.notify({
            title: "Success",
            text: "Account Saved Successfully",
            color: "success",
            iconPack: "feather",
            icon: "icon-check",
            position: "bottom-center"
          });
        })
        .catch(() => {});
    },
    addAdditionalContact() {
      this.additionalContacts.push({
        name: "",
        email: "",
        phone: ""
      });
    },
    confirmDeleteCustomer() {
      this.$delete(`/accounts/${this.account.id}`)
        .then(() => {
          this.$vs.notify({
            title: "Successfully deleted",
            color: "success",
            iconPack: "feather",
            icon: "icon-alert-circle",
            position: "bottom-right"
          });
          this.$router.push("/accounts");
        })
        .catch(() => {});
    },
    deleteCustomer() {
      this.$vs.dialog({
        type: "confirm",
        color: "warning",
        title: `Are you sure?`,
        text:
          "This cannot be undone and you will lose all client data and tickets.",
        accept: () => this.confirmDeleteCustomer()
      });
    },
    getTicketCount(orderItems) {
      let count = 0;
      orderItems.forEach(({ quantity }) => {
        count += quantity;
      });
      console.log("COUNTTTTTT", count);
      return count;
    },
    async refreshCredits() {
      $load(".stats-card > div ");
      let { data } = await this.$get(`/accounts/${this.account.id}/tickets`);
      this.credits = data;
      console.log(this.credits);
      $load(".stats-card > div ", false);
    },
    async getFunds() {
      let { data: funds } = await this.$get(
        `/ticket-orders/active?account=${this.account.id}`
      );
      this.allFunds = arrToObj(funds);

      let { data: ordered } = await this.$get(
        `/ticket-orders?_sort=updatedAt:DESC&_limit=5&account=${this.account.id}`
      );
      let { data: used } = await this.$get(
        `/ticket-useds?_sort=updatedAt:DESC&_limit=5&ticketOrder.account=${this.account.id}`
      );
      let { data: paid } = await this.$get(
        `/payments?_sort=updatedAt:DESC&_limit=5&ticketOrder.account=${this.account.id}`
      );

      paid = paid.filter(
        x => x.ticketOrder && x.ticketOrder.account === this.account.id
      );
      used = used.filter(
        x => x.ticketOrder && x.ticketOrder.account === this.account.id
      );

      ordered = ordered.map(x => ({ ...x, what: "ordered" }));
      used = used.map(x => ({ ...x, what: "used" }));
      paid = paid.map(x => ({ ...x, what: "paid" }));

      let activities = [...ordered, ...used, ...paid];

      activities = activities.sort(({ createdAt: a }, { createdAt: b }) => {
        if (a > b) return -1;
        return 1;
      });
      this.activities = activities;
    },
    releaseFunds() {
      $loading();

      let { id, amount, product, max } = this.fund;

      this.$api
        .post(`/tickets-releaseds`, {
          product,
          quantity: amount,
          uid: Date.now() + "",
          ticketOrder: id
        })
        .then(async ({ data }) => {
          data.product = data.product.id;
          data.ticketOrder = data.ticketOrder.id;

          if (this.allFunds[id]) {
            if (!this.allFunds[id].ticketsReleased) {
              setProp(this.allFunds[id], ["ticketsReleased"], []);
            }
            setProp(
              this.allFunds[id].ticketsReleased,
              [this.allFunds[id].ticketsReleased.length],
              data
            );
          }
        })
        .catch(err => {
          this.$vs.notify({
            title: "An Error occurred",
            text: `Could not release funds. Please try again.`,
            color: "danger",
            iconPack: "feather",
            icon: "icon-alert-circle",
            position: "bottom-right"
          });
        })
        .finally(e => {
          $loading.close();
          this.refreshCredits();
          this.fund.show = false;
          this.fund.max = 3829832;
          this.fund.id = "";
          this.fund.product = "";
          this.fund.amount = 1;
        });
    },
    cancelRelease() {},
    cancelPayment() {},
    makePayment() {
      console.log("MAKING PAYMENT", this.payment);
      $loading();

      let {
        id,
        amount,
        ticketOrder,
        referenceId,
        balance,
        type
      } = this.payment;
      if (isNaN(+amount)) return console.error("amount not proper number");
      amount = +amount;
      amount = parseFloat(amount.toFixed(2));
      let fullyPaid = false;
      if (amount >= balance) {
        fullyPaid = true;
        amount = balance;
      }

      let sendObj = {
        amount,
        referenceId,
        ticketOrder,
        uid: "d" + Date.now(),
        date: this.payment.date.toString(),
        account: this.account.id,
        type
      };

      this.$api
        .post(`/payments`, sendObj)
        .then(async ({ data }) => {
          data.ticketOrder = data.ticketOrder.id;

          if (this.allFunds[ticketOrder]) {
            if (!this.allFunds[ticketOrder].payments) {
              setProp(this.allFunds[ticketOrder], ["payments"], []);
            }
            setProp(
              this.allFunds[ticketOrder].payments,
              [this.allFunds[ticketOrder].payments.length],
              data
            );
          }
        })
        .catch(err => {
          this.$vs.notify({
            title: "An Error occurred",
            text: `Could not make payments funds. Please try again.`,
            color: "danger",
            iconPack: "feather",
            icon: "icon-alert-circle",
            position: "bottom-right"
          });
        })
        .finally(e => {
          $loading.close();
          this.refreshCredits();
          this.payment.show = false;
          this.payment.balance = 3829832;
          this.payment.ticketOrder = "";
          this.payment.amount = 1;
        });
    },
    addPayment(fund) {
      this.payment.amount = fund.balance;
      this.payment.balance = fund.balance;
      this.payment.show = true;
      this.payment.type = fund.type === "overdraft" ? "cheque" : fund.type;
      this.payment.ticketOrder = fund.id;
      this.payment.referenceId = "";
      this.payment.date = new Date();
    },
    release(fund) {
      console.log("CHECKING IF SUPER", fund);

      if (!this.$store.getters.isSuper) {
        return this.$vs.notify({
          title: "Error",
          text: `You dont have permission to do that!`,
          color: "danger",
          iconPack: "feather",
          icon: "icon-alert-circle",
          position: "bottom-right"
        });
      }

      this.fund.amount = 1;
      this.fund.max = fund.item.quantity - fund.item.released;
      this.fund.show = true;
      this.fund.id = fund.id;
      this.fund.product = fund.item.product.id;
    },
    markAsPaid(id) {
      this.$api
        .put(`/transactions/fund`, { transaction: id, qty: -1 })
        .then(async ({ data }) => {
          let { data: credits } = await this.$api.get(
            `/credits?account=${this.account.id}`
          );
          let accountCredits = {};

          credits.forEach(credit => {
            if (!credit.product || !credit.product.id) return;
            if (!credit.amount) credit.amount = 0;
            let pId = credit.product.id;

            if (!accountCredits[pId])
              accountCredits[pId] = { product: credit.product, amount: 0 };
            accountCredits[pId].amount += credit.amount;
          });

          setProp(this.$data, ["credits"], accountCredits);
          deleteProp(this.funds, [data.id]);
        })
        .catch(err => {})
        .finally(e => {
          $loading.close();
        });
    },
    markPaid(fund) {
      if (!this.$store.getters.isSuper) {
        return this.$vs.notify({
          title: "Error",
          text: `You dont have permission to do that!`,
          color: "danger",
          iconPack: "feather",
          icon: "icon-alert-circle",
          position: "bottom-right"
        });
      }
      this.$vs.dialog({
        type: "confirm",
        color: "warning",
        title: `Marking Complete`,
        text:
          "You are about to mark this fund request as paid. This will release all funds.",
        accept: () => this.markAsPaid(fund.id)
      });
    },
    updatePreferences() {
      let options = JSON.parse(JSON.stringify(this.options));

      this.$update(`/accounts/${this.account.id}`, { options })
        .then(({ data }) => {
          this.$store.commit("SET_PROP", {
            where: ["accounts", data.id],
            what: data
          });
          this.$vs.notify({
            title: "Success",
            text: "Account Saved Successfully",
            color: "success",
            iconPack: "feather",
            icon: "icon-check",
            position: "bottom-center"
          });
        })
        .catch(() => {});
    },

    async addItem(where) {
      let item = false;
      let itemLabel = "";

      if (where === "trucks") {
        itemLabel = "Truck";
        item = {
          name: this.truck.name,
          licPlate: this.truckLic,
          qr: Date.now() + this.account.id,
          accid: this.account.id,
          account: this.account.id
        };
        let { data: dup } = await this.$api.get(
          "/trucks?licPlate=" + this.truckLic
        );
        if (dup && dup.length) {
          return this.$vs.notify({
            color: "danger",
            title: "License Plate has to be unique.",
            text:
              "This License Plate already exists in the system. Please try again."
          });
        }
      } else if (where === "drivers") {
        itemLabel = "Driver";
        item = {
          ...this.driver,
          account: this.account.id
        };
      }

      if (!item) return console.error("ERROR HAPPENED");

      this.$api
        .post(`/${where}`, item)
        .then(({ data }) => {
          setProp(this.$data, [where, data.id], data);
          this.$vs.notify({
            color: "success",
            title: itemLabel + " Created"
          });
        })
        .catch(err => {
          console.error("ERROR", err);
        });
    },

    close() {
      // this.$vs.notify({
      //     color:'danger',
      //     title:'Closed',
      //     text:'You close a dialog!'
      // })
    },

    clearValMultiple() {
      this.truck = {
        name: "",
        licPlate: ""
      };
      this.driver = {
        firstName: "",
        lastName: "",
        lic: ""
      };
    },

    deleteItem(where, what) {
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: `Confirm Deletion`,
        text:
          "You are about to delete an item. Please confirm that this is the action you want to perform.",
        accept: () => this.acceptDelete(where, what)
      });
    },

    async acceptDelete(where, what) {
      this.$api
        .delete(`/${where}/${what.id}`)
        .then(({ data }) => {
          this.$vs.notify({
            color: "danger",
            title: "Deleted!",
            text: `The selected item was successfully deleted`
          });
          // let idx = this.$data[where].findIndex(x => x.id === what.id)
          deleteProp(this.$data, [where, what.id]);
        })
        .catch(err => {
          console.error("ERROR", err);
        });
    },
    async update(where, what) {
      console.log("UPDATING", where);
      console.log("on ", what);
      this.$api
        .put(`/${where}/${what.id}`, what)
        .then(({ data }) => {
          this.$vs.notify({
            title: "Success",
            text: "Updated Successfully",
            color: "success",
            iconPack: "feather",
            icon: "icon-check",
            position: "bottom-center"
          });
          document.body.click();
        })
        .catch(err => {
          console.error("ERROR", err);
        });
    },
    async qrClick(tr) {
      return window.open("https://api.resoilsolutions.com/v1/qr/" + tr.id);
    },
    async save() {
      let sendObj = JSON.parse(JSON.stringify(this.account));

      let { data } = await this.$update(
        `/accounts/${this.account.id}`,
        sendObj
      );
      if (data.id) {
        this.$store.commit("SET_PROP", {
          where: ["accounts", data.id],
          what: data
        });
        this.$vs.notify({
          title: "Success",
          text: "Account Saved Successfully",
          color: "success",
          iconPack: "feather",
          icon: "icon-check",
          position: "bottom-center"
        });
        this.$router.push({ path: "/accounts" });
      }
    },
    async trStatus(tr){
      await this.update('trucks', tr)
    },
    async drStatus(tr){
      await this.update('drivers', tr)
    }
  },
  async created() {
    this.additionalContacts = [
      {
        name: "",
        phone: "",
        email: ""
      }
    ];
    let {
      user,
      trucks = [],
      drivers = [],
      overDraftLimit = 0,
      quickReleaseLimit = 0,
      lowFundThreshold = 1,
      contacts = [],
      options = {},
      ...account
    } = JSON.parse(JSON.stringify(this.$store.state.currentAccount));
    if (!account.code) account.code = "";
    let relations = {};
    relations.user = user.id;
    relations.trucks = trucks.map(x => x.id);
    relations.drivers = drivers.map(x => x.id);

    this.relations = relations;

    if (!options) options = {};
    if (!options.overDraft) options.overDraft = {};
    if (!options.quickRelease) options.quickRelease = {};
    if (!options.minNotification) options.minNotification = {};

    if (!contacts || !contacts.length)
      contacts = [
        {
          name: "",
          phone: "",
          email: ""
        }
      ];
    console.log("CONTACTSSSSSS", contacts);
    this.additionalContacts = contacts;

    let { data: prds } = await this.$api.get("/products");
    let productObj = {};

    prds.forEach(prd => {
      if (!options.overDraft.hasOwnProperty(prd.id))
        options.overDraft[prd.id] = 0;
      if (!options.quickRelease.hasOwnProperty(prd.id))
        options.quickRelease[prd.id] = 0;
      if (!options.minNotification.hasOwnProperty(prd.id))
        options.minNotification[prd.id] = 0;
      productObj[prd.id] = prd;
    });

    this.options = options;
    this.productObj = productObj;

    if (!account.name) account.name = "Unnamed";

    this.account = account;
    this.trucks = arrToObj(trucks);
    this.drivers = arrToObj(drivers);

    this.user = user;
    this.userEmail = user.email;

    if (!this.$store.getters.isManageTruckDriverOnly) {
      this.getFunds();
    }

    this.$store.commit("SET_PROP", {
      where: ["crumbName"],
      what: account.name
    });

    this.refreshCredits();
  },
  mounted() {
    if (this.$refs.chatLogPS) {
      this.$refs.chatLogPS.$el.scrollTop = this.$refs.chatLog.scrollHeight;
    }
  }
};
</script>

<style lang="scss">
#demo-basic-card {
  .overlay-card {
    .vx-card__collapsible-content {
      max-height: 485px;
    }
  }

  .chat-card-log {
    height: 360px;

    .chat-sent-msg {
      background-color: #f2f4f7 !important;
    }
  }

  .card-video {
    .video-js {
      height: 370px;
    }
  }
}

/* Toggle */
.truckStyle .dot {
  top: 0;
  right: 50%;
}
.truckStyle input:checked ~ .dot {
  transform: translateX(100%) !important;
  background-color: #598d7f !important;
}
</style>
